import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { VscDiffAdded } from 'react-icons/vsc';
import { BiTrash } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { failureAlert, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import moment from 'moment';
import { viewImage } from '../../CommonUtils/viewImage';
import { FaEye } from 'react-icons/fa';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { GetMediumList } from '../../Reducers/AffiliationCommonservice';
export default function AfflApprovalProceedingsUpload() {
    const dispatch = useDispatch();
    const acYear = sessionStorage.getItem('ac_year');
    const MediumData = useSelector((state) => state?.commonMastersReducer?.Medium);
    const Afflapprovalproceedingsvalidation = Yup.object({
        isBbaBcaCourses: Yup.string().required(ERROR_MSG).nullable(),
        issuanceDate: Yup.string().required(ERROR_MSG).nullable(),
        aicteProceeding: Yup.string().required(ERROR_MSG).nullable(),
        courses: Yup.array().when('isBbaBcaCourses', {
            is: 'Yes',
            then: Yup.array().of(
                Yup.object().shape({
                    singlemagor: Yup.string().required(ERROR_MSG).nullable(),
                    courseId: Yup.string().required(ERROR_MSG).nullable(),
                    mediumCode: Yup.string().required(ERROR_MSG).nullable(),
                    regSelf: Yup.string().required(ERROR_MSG).nullable(),
                    courseAfflType: Yup.string().required(ERROR_MSG).nullable(),
                    finalSanctionIntake: Yup.string().required(ERROR_MSG).nullable(),
                    approvNoOfSections: Yup.string().required(ERROR_MSG).nullable(),
                })
            ),
            otherwise: Yup.array().nullable(),
        }),
    });
    const [getAicteApproval, setAicteApproval] = useState([]);
    const Uploadbbaformik = useFormik({
        enableReinitialize: true,
        initialValues: {
            isBbaBcaCourses: "",
            issuanceDate: "",
            aicteProceeding: "",
            courses: [
                {
                    singlemagor: "",
                    courseId: "",
                    mediumCode: "",
                    regSelf: "",
                    courseAfflType: "",
                    finalSanctionIntake: "",
                    approvNoOfSections: "",
                }
            ],
        },
        validationSchema: Afflapprovalproceedingsvalidation,
        onSubmit: (values) => {
            values.courses.forEach(course => {
                course.finalSanctionIntake = parseInt(course.finalSanctionIntake, 10) || 0;
                course.courseId = parseInt(course.courseId, 10) || 0;
                course.mediumCode = parseInt(course.mediumCode, 10) || 0;
                course.approvNoOfSections = parseInt(course.approvNoOfSections, 10) || 0;
            });
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}AicteApprovalProceedings`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlertRefresh(res?.data?.sdesc);
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })
    const [spec, setSpec] = useState([]);

    function GetSpecializations(courseCatId, index) {
        let url = config.url.API_URL + `getSpecilization/${courseCatId}`;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = res?.data?.Specilization;
                    return updatedSpecs;
                });
            } else {
                setSpec(prevSpecs => {
                    const updatedSpecs = [...prevSpecs];
                    updatedSpecs[index] = [];
                    return updatedSpecs;
                });
            }
        });
    }


    function getAicteApprovalProceedings() {
        let url = config.url.API_URL + `getAicteApprovalProceedings`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAicteApproval(res?.data?.courseDetails);
                const rawDate = res?.data?.courseDetails[0]?.issuance_date;
                const issuanceDate = rawDate && moment(rawDate, 'YYYY-MM-DD', true).isValid()
                    ? moment(rawDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                    : null;
                Uploadbbaformik?.setFieldValue("isBbaBcaCourses", res?.data?.courseDetails[0]?.is_bba_bca_courses?.toString() ?? '');
                Uploadbbaformik?.setFieldValue("aicteProceeding", res?.data?.courseDetails[0]?.aicte_proceeding?.toString() ?? '');
                Uploadbbaformik?.setFieldValue("issuanceDate", issuanceDate);

                res?.data?.courseDetails?.forEach((course, i) => {
                    Uploadbbaformik?.setFieldValue(`courses[${i}].singlemagor`, course?.course_cat_id);
                    GetSpecializations(course.course_cat_id, i);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].courseId`, course?.course_id);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].mediumCode`, course?.medium_code);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].regSelf`, course?.reg_self);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].courseAfflType`, course?.course_affl_type);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].finalSanctionIntake`, course?.final_sanction_intake);
                    Uploadbbaformik?.setFieldValue(`courses[${i}].approvNoOfSections`, course?.approv_no_of_sections);
                })
            }
            else {
                setAicteApproval([]);
            }
        })
    }
    useEffect(() => {
        getAicteApprovalProceedings();
        GetMediumList();
    }, [])
    return (

        <>
            <bie.Container fluid className="px-1" style={{ border: '0.1px solid black' }}>
                <CommonFormHeading heading="Upload AICTE Proceedings (If BBA/BCA Courses are available) Academic year" />
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }} >
                    <FormikProvider value={Uploadbbaformik}>
                        <Form onChange={Uploadbbaformik.handleChange} onSubmit={Uploadbbaformik.handleSubmit} className="form_adjust">
                            <bie.Row >
                                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} classname='mb-3'>
                                    <bie.InputGroup >
                                        <span className="label-text-style"><b style={{ color: 'red' }}>* </b>Is the college having BBA/BCA Courses</span>
                                    </bie.InputGroup></bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} classname='mb-3'>
                                    <bie.InputGroup >
                                        <Field as="select" name="isBbaBcaCourses" className="form-control " >
                                            <option value="">--Select--</option>
                                            <option value="Yes">Yes</option>
                                            {/* <%-- <html:option value="No">No</html:option> --%> */}
                                        </Field>
                                        <ErrorMessage name="isBbaBcaCourses" component="div" className="text-error" />
                                    </bie.InputGroup>
                                </bie.Col>
                            </bie.Row>
                            <bie.Row >
                                {Uploadbbaformik?.values?.isBbaBcaCourses === "Yes" ? (<>
                                    <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4} className='mb-3 pt-3'>
                                        <bie.InputGroup>
                                            <span className="label-text-style"><b style={{ color: 'red' }}>* </b>Upload Approval Proceedings Issued by AICTE for {acYear} :</span>
                                        </bie.InputGroup></bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3 pt-3'>
                                        <bie.InputGroup>
                                            <div className='form-control'>
                                                <input type="file" name="aicteProceeding" className="form-control" accept="application/pdf"
                                                    onChange={(e) => {
                                                        let filename = `AicteProceeding`;
                                                        let path = "/Uploads/AffiliationPDFs/2024/Aicte_Proceedings/";
                                                        ImagePdfBucket(e, Uploadbbaformik, path, `aicteProceeding`, filename, "pdf");
                                                    }}
                                                />
                                            </div>
                                            <ErrorMessage name="aicteProceeding" component="div" className="text-error" />
                                            {Uploadbbaformik?.values?.aicteProceeding && <button type='button' className='btn btn-primary' onClick={() => { viewImage(Uploadbbaformik?.values?.aicteProceeding) }}><FaEye size={20} /> </button>}
                                        </bie.InputGroup>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-3 pt-3' >
                                        <bie.InputGroup>
                                            <span className="label-text-style"><b style={{ color: 'red' }}>* </b>Date Of Issuance :</span>
                                        </bie.InputGroup></bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-3 pt-3' >
                                        <bie.InputGroup>
                                            <Field
                                                type="date"
                                                name="issuanceDate"
                                                className="form-control" onKeyDown={(e) => { e.preventDefault() }}
                                            // max={(() => {
                                            //     const today = new Date();
                                            //     today.setFullYear(today.getFullYear() - 21);
                                            //     return today.toISOString().split("T")[0];
                                            // })()}
                                            />
                                            <ErrorMessage name="issuanceDate" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>
                                </>) : (<></>)}
                            </bie.Row>
                            {Uploadbbaformik?.values?.isBbaBcaCourses === "Yes" ? (<>

                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive">
                                        <thead>
                                            <tr>
                                                <th>  S.No	</th>
                                                <th >Single Major </th>
                                                <th >Specialization</th>
                                                <th >Medium</th>
                                                <th >Regular/Self-Financed</th>
                                                <th >Affiliation Permanent/Temporary</th>
                                                <th >Intake being requested by College for this academic year {acYear} </th>
                                                <th>Number of Sections being requested</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <FieldArray name="courses">
                                                {(QualificationValues) => {
                                                    return QualificationValues.form.values.courses.map((qual, index) => {
                                                        return (
                                                            <>
                                                                <tr key={index}>
                                                                    <td>
                                                                        <center>{index + 1}</center>
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control form-control-md" name={`courses[${index}].singlemagor`}
                                                                            onChange={(e) => GetSpecializations(e.target.value, index)}>
                                                                            <option value=''>---select---</option>
                                                                            <option value="86">BBA Honours</option>
                                                                            <option value="87">BCA Honours</option>
                                                                            <option value="90">BMS Honours</option>
                                                                        </Field>
                                                                        <ErrorMessage name={`courses[${index}].singlemagor`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control form-control-md" name={`courses[${index}].courseId`}>

                                                                            <option value=''>--select--</option>
                                                                            {spec[index] && spec[index].map((sp, i) => (
                                                                                <option key={i} value={sp?.course_id}>{sp?.course_name}</option>
                                                                            ))}

                                                                        </Field>
                                                                        <ErrorMessage name={`courses[${index}].courseId`} component="div" className="text-error" />
                                                                    </td>
                                                                    <td>
                                                                        <Field as="select" className="form-control mt-1" name={`courses[${index}].mediumCode`}>
                                                                            <option value=''>---select---</option>
                                                                            {MediumData && MediumData?.map((rel, i) => (
                                                                                <option value={rel?.medium_code}>{rel?.name}</option>
                                                                            ))}

                                                                        </Field>

                                                                        <ErrorMessage name={`courses[${index}].mediumCode`} component="div" className="text-error" /></td>

                                                                    <td>
                                                                        <Field as="select" className="form-control mt-1" name={`courses[${index}].regSelf`}
                                                                        // onChange={(e) => { GetSroDist(e?.target?.value, index) }}
                                                                        >
                                                                            <option value=''>--select--</option>
                                                                            <option value='R'>Regular</option>
                                                                            <option value='S'>Self-Financed</option>
                                                                        </Field>
                                                                        <ErrorMessage name={`courses[${index}].regSelf`} component="div" className="text-error" /></td>
                                                                    <td>
                                                                        <Field as="select" className="form-control mt-1" name={`courses[${index}].courseAfflType`}>
                                                                            <option value=''>--select--</option>
                                                                            <option value="Permanent">Permanent</option>
                                                                            <option value="Temporary">Temporary</option>
                                                                        </Field>
                                                                        <ErrorMessage name={`courses[${index}].courseAfflType`} component="div" className="text-error" /></td>
                                                                    <td>
                                                                        <Field type="text" className="form-control mt-1" name={`courses[${index}].finalSanctionIntake`} maxLength="5" />
                                                                        <ErrorMessage name={`courses[${index}].finalSanctionIntake`} component="div" className="text-error" />

                                                                    </td>

                                                                    <td>
                                                                        <Field type="text" className="form-control mt-1" name={`courses[${index}].approvNoOfSections`}
                                                                            maxLength="2" />
                                                                        <ErrorMessage name={`courses[${index}].approvNoOfSections`} component="div" className="text-error" />

                                                                    </td>
                                                                    <td align="center">
                                                                        {index === 0 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-success"
                                                                                onClick={() => {
                                                                                    QualificationValues?.push({
                                                                                        singlemagor: "",
                                                                                        courseId: "",
                                                                                        mediumCode: "",
                                                                                        regSelf: "",
                                                                                        courseAfflType: "",
                                                                                        finalSanctionIntake: "",
                                                                                        approvNoOfSections: "",

                                                                                    });
                                                                                }}>
                                                                                <VscDiffAdded></VscDiffAdded>{" "}
                                                                            </button>
                                                                        ) : ""}

                                                                        {index >= 1 ? (
                                                                            <button
                                                                                type="button"
                                                                                className="button-titile btn btn-sm btn-danger"
                                                                                onClick={() => QualificationValues.remove(index)}>
                                                                                <BiTrash></BiTrash>
                                                                            </button>
                                                                        ) : ""}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        );
                                                    });
                                                }}
                                            </FieldArray>
                                        </tbody>
                                    </table>
                                </div>
                            </>) : (<></>)}
                            <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>Submit</button>

                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>

        </>
    )
}
